import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation, useNavigate } from 'react-router-dom';
import Header from './components/Header';
import Sidebar from './components/Sidebar';
import Dashboard from './components/Dashboard';
import ManageUser from './components/ManageUser';
import CustomerContents from './components/CustomerContents';
import Admin from './components/Admin';
import Alimtalk from './components/Alimtalk';
import FindPassword from './components/FindPassword';
import MarketingInfo from './components/MarketingInfo';
import RankSearch from './components/RankSearch';
import NotFound from './components/NotFound';
import { AuthProvider, useAuth } from './hooks/useAuth';
import './App.css';

// 로그인 페이지 컴포넌트
const LoginPage = () => {
  const [activeTab, setActiveTab] = useState('login');
  const [userId, setUserId] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [loginError, setLoginError] = useState('');
  const [signupData, setSignupData] = useState({
    name: '',
    company: '',
    email: '',
    phone: '',
    password: '',
    confirmPassword: '',
    agreeTerms: false
  });
  const [showSignupPassword, setShowSignupPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const navigate = useNavigate();
  
  // 인증 훅 사용
  const { login, signup, isLoading } = useAuth();

  const handleLoginSubmit = async (e) => {
    e.preventDefault();
    setLoginError('');
    
    const result = await login(userId, password, rememberMe);
    if (result.success) {
      navigate('/Admin/dashboard');
    } else {
      setLoginError(result.error);
    }
  };

  const handleSignupSubmit = async (e) => {
    e.preventDefault();
    setLoginError('');
    
    // 비밀번호 확인 검증
    if (signupData.password !== signupData.confirmPassword) {
      setLoginError('비밀번호가 일치하지 않습니다.');
      return;
    }
    
    // 이용약관 동의 확인
    if (!signupData.agreeTerms) {
      setLoginError('이용약관에 동의해주세요.');
      return;
    }
    
    const result = await signup(signupData);
    
    if (result.success) {
      alert('회원가입이 완료되었습니다. 로그인해주세요.');
      setActiveTab('login');
      // 회원가입 폼 초기화
      setSignupData({
        name: '',
        company: '',
        email: '',
        phone: '',
        password: '',
        confirmPassword: '',
        agreeTerms: false
      });
    } else {
      setLoginError(result.error);
    }
  };

  const handleSignupChange = (field, value) => {
    setSignupData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  return (
<div className="App">
      <div className="login-container">
        <div className="login-form">
          <div className="profile-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-user w-8 h-8 text-white" aria-hidden="true"><path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
          </div>
          <h1 className="login-title">
            {activeTab === 'login' ? '로그인' : '회원가입'}
          </h1>
          <p className="login-subtitle">
            {activeTab === 'login' 
              ? '계정에 로그인하여 대시보드를 이용하세요' 
              : '새 계정을 만들어 서비스를 시작하세요'
            }
          </p>
          {/* <div className="tab-container">
            <button 
              className={`tab ${activeTab === 'login' ? 'active' : ''}`}
              onClick={() => setActiveTab('login')}
            >
              로그인
            </button>
            <button 
              className={`tab ${activeTab === 'signup' ? 'active' : ''}`}
              onClick={() => setActiveTab('signup')}
            >
              회원가입
            </button>
          </div> */}
          {activeTab === 'login' && (
            <form onSubmit={handleLoginSubmit} className="login-form-content">
              {loginError && (
                <div className="error-message" style={{
                  color: '#dc2626',
                  backgroundColor: '#fef2f2',
                  border: '1px solid #fecaca',
                  borderRadius: '6px',
                  padding: '12px',
                  marginBottom: '16px',
                  fontSize: '14px'
                }}>
                  {loginError}
                </div>
              )}
              <div className="input-group">
                <label htmlFor="userId">아이디 *</label>
                <input
                  type="text"
                  id="userId"
                  placeholder="아이디를 입력하세요"
                  value={userId}
                  onChange={(e) => setUserId(e.target.value)}
                  required
                  disabled={isLoading}
                />
              </div>
              <div className="input-group">
                <label htmlFor="password">비밀번호 *</label>
                <div className="password-input-container">
                  <input
                    type={showPassword ? 'text' : 'password'}
                    id="password"
                    placeholder="비밀번호를 입력하세요"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    disabled={isLoading}
                  />
                  <button
                    type="button"
                    className="password-toggle"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? (
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-eye-off h-5 w-5 text-gray-400" aria-hidden="true"><path d="M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575 1 1 0 0 1 0 .696 10.747 10.747 0 0 1-1.444 2.49"></path><path d="M14.084 14.158a3 3 0 0 1-4.242-4.242"></path><path d="M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151 1 1 0 0 1 0-.696 10.75 10.75 0 0 1 4.446-5.143"></path><path d="m2 2 20 20"></path></svg>
                    ) : (
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-eye h-5 w-5 text-gray-400" aria-hidden="true"><path d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0"></path><circle cx="12" cy="12" r="3"></circle></svg>
                    )}
                  </button>
                </div>
              </div>
              <div className="form-options">
                <label className="checkbox-container">
                  <input
                    type="checkbox"
                    checked={rememberMe}
                    onChange={(e) => setRememberMe(e.target.checked)}
                  />
                  <span className="checkmark"></span>
                  로그인 상태 유지
                </label>
                {/* <button type="button" className="forgot-password" onClick={() => navigate('/Admin/findpassword')}>비밀번호 찾기</button> */}
              </div>
              <button type="submit" className="login-button" disabled={isLoading}>
                {isLoading ? '로그인 중...' : '로그인'}
              </button>
              {/* <div className="dashboard-link" onClick={() => window.location.href = '/Admin/dashboard'}>
                🏠 대시보드로 바로 이동 (임시)
              </div> */}
            </form>
          )}
          {activeTab === 'signup' && (
            <form onSubmit={handleSignupSubmit} className="login-form-content">
              {loginError && (
                <div className="error-message" style={{
                  color: '#dc2626',
                  backgroundColor: '#fef2f2',
                  border: '1px solid #fecaca',
                  borderRadius: '6px',
                  padding: '12px',
                  marginBottom: '16px',
                  fontSize: '14px'
                }}>
                  {loginError}
                </div>
              )}
              <div className="input-row">
                <div className="input-group half">
                  <label htmlFor="name">이름 *</label>
                  <input
                    type="text"
                    id="name"
                    placeholder="이름을 입력하세요"
                    value={signupData.name}
                    onChange={(e) => handleSignupChange('name', e.target.value)}
                    required
                  />
                </div>
                <div className="input-group half">
                  <label htmlFor="company">회사명 *</label>
                  <input
                    type="text"
                    id="company"
                    placeholder="회사명을 입력하세요"
                    value={signupData.company}
                    onChange={(e) => handleSignupChange('company', e.target.value)}
                    required
                  />
                </div>
              </div>
              <div className="input-group">
                <label htmlFor="signup-email">이메일 *</label>
                <input
                  type="email"
                  id="signup-email"
                  placeholder="이메일을 입력하세요"
                  value={signupData.email}
                  onChange={(e) => handleSignupChange('email', e.target.value)}
                  required
                />
              </div>
              <div className="input-group">
                <label htmlFor="phone">전화번호 *</label>
                <input
                  type="tel"
                  id="phone"
                  placeholder="010-1234-5678"
                  value={signupData.phone}
                  onChange={(e) => handleSignupChange('phone', e.target.value)}
                  required
                />
              </div>
              <div className="input-group">
                <label htmlFor="signup-password">비밀번호 *</label>
                <div className="password-input-container">
                  <input
                    type={showSignupPassword ? 'text' : 'password'}
                    id="signup-password"
                    placeholder="비밀번호를 입력하세요 (8자 이상)"
                    value={signupData.password}
                    onChange={(e) => handleSignupChange('password', e.target.value)}
                    required
                    minLength="8"
                  />
                  <button
                    type="button"
                    className="password-toggle"
                    onClick={() => setShowSignupPassword(!showSignupPassword)}
                  >
                    {showSignupPassword ? (
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-eye-off h-5 w-5 text-gray-400" aria-hidden="true"><path d="M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575 1 1 0 0 1 0 .696 10.747 10.747 0 0 1-1.444 2.49"></path><path d="M14.084 14.158a3 3 0 0 1-4.242-4.242"></path><path d="M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151 1 1 0 0 1 0-.696 10.75 10.75 0 0 1 4.446-5.143"></path><path d="m2 2 20 20"></path></svg>
                    ) : (
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-eye h-5 w-5 text-gray-400" aria-hidden="true"><path d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0"></path><circle cx="12" cy="12" r="3"></circle></svg>
                    )}
                  </button>
                </div>
              </div>
              <div className="input-group">
                <label htmlFor="confirm-password">비밀번호 확인 *</label>
                <div className="password-input-container">
                  <input
                    type={showConfirmPassword ? 'text' : 'password'}
                    id="confirm-password"
                    placeholder="비밀번호를 다시 입력하세요"
                    value={signupData.confirmPassword}
                    onChange={(e) => handleSignupChange('confirmPassword', e.target.value)}
                    required
                  />
                  <button
                    type="button"
                    className="password-toggle"
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  >
                    {showConfirmPassword ? (
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-eye-off h-5 w-5 text-gray-400" aria-hidden="true"><path d="M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575 1 1 0 0 1 0 .696 10.747 10.747 0 0 1-1.444 2.49"></path><path d="M14.084 14.158a3 3 0 0 1-4.242-4.242"></path><path d="M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151 1 1 0 0 1 0-.696 10.75 10.75 0 0 1 4.446-5.143"></path><path d="m2 2 20 20"></path></svg>
                    ) : (
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-eye h-5 w-5 text-gray-400" aria-hidden="true"><path d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0"></path><circle cx="12" cy="12" r="3"></circle></svg>
                    )}
                  </button>
                </div>
              </div>
              <div className="form-options signup-terms">
                <label className="checkbox-container">
                  <input
                    type="checkbox"
                    checked={signupData.agreeTerms}
                    onChange={(e) => handleSignupChange('agreeTerms', e.target.checked)}
                    required
                  />
                  <span className="checkmark"></span>
                  <span className="terms-text">
                    <button type="button" className="terms-link">이용약관</button> 및 <button type="button" className="terms-link">개인정보처리방침</button>에 동의합니다 *
                  </span>
                </label>
              </div>
              <button type="submit" className="login-button" disabled={isLoading}>
                {isLoading ? '회원가입 중...' : '회원가입'}
              </button>
            </form>
          )}
          {/* <div className="signup-link">
            {activeTab === 'login' 
              ? <>계정이 없으신가요? <button type="button" onClick={() => setActiveTab('signup')}>회원가입</button></>
              : <>이미 계정이 있으신가요? <button type="button" onClick={() => setActiveTab('login')}>로그인</button></>
            }
          </div> */}
        </div>
      </div>
    </div>
    
  );
};

// 현재 경로에 따른 활성 메뉴 결정
const getActiveMenu = (pathname) => {
  if (pathname === '/Admin/dashboard') return 'dashboard';
  if (pathname === '/Admin/manageUser') return 'customer-management';
  if (pathname === '/Admin/customer-contents') return 'customer-contents';
  if (pathname === '/Admin/config') return 'admin';
  if (pathname === '/Admin/alimtalk') return 'alimtalk';
  return 'dashboard';
};

// 대시보드 레이아웃 컴포넌트
const DashboardLayout = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const location = useLocation();
  const activeMenu = getActiveMenu(location.pathname);
  const handleToggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  const handleCloseSidebar = () => {
    setIsSidebarOpen(false);
  };
  return (
    <div className="dashboard-layout">
      <Header 
        onToggleSidebar={handleToggleSidebar}
        isSidebarOpen={isSidebarOpen}
      />
      <Sidebar 
        activeMenu={activeMenu}
        isOpen={isSidebarOpen}
        onClose={handleCloseSidebar}
      />
      {children}
    </div>
  );
};

function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          <Route path="/Admin" element={<LoginPage />} />
          <Route path="/Admin/findpassword" element={<FindPassword />} />
          <Route path="/Admin/dashboard" element={<DashboardLayout><Dashboard /></DashboardLayout>} />
          <Route path="/Admin/manageUser" element={<DashboardLayout><ManageUser /></DashboardLayout>} />
          <Route path="/Admin/customer-contents" element={<DashboardLayout><CustomerContents /></DashboardLayout>} />
          <Route path="/Admin/config" element={<DashboardLayout><Admin /></DashboardLayout>} />
          <Route path="/Admin/alimtalk" element={<DashboardLayout><Alimtalk /></DashboardLayout>} />
          <Route path="/marketingInfo/:uid" element={<MarketingInfo />} />
          <Route path="/rankSearch" element={<RankSearch />} />
          {/* <Route path="/" element={<Navigate to="/Admin" replace />} /> */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;
